import {
  UPDATE_COLLECTION,
  CREATE_COLLECTION,
  DELETE_COLLECTION,
  ADD_CARD_TO_COLLECTION,
  REMOVE_CARD_FROM_COLLECTION,
} from 'js/store/collections/Collections.actions.js';

const initState = {
  userCollections: {
    byId: {},
    allIds: [],
    byCardId: {},
  },
};

const collections = (state = initState, action) => {
  let nextState = {};

  switch (action.type) {
    case UPDATE_COLLECTION: {
      const { id, name, removeCards } = action.payload;
      const collection = state.userCollections.byId[id];
      if (!collection) return state;

      nextState.userCollections = {
        ...state.userCollections,
        byId: {
          ...state.userCollections.byId,
          [id]: {
            ...collection,
            name,
            cards: collection.cards.filter((cardId) => !removeCards.includes(cardId)),
          },
        },
      };

      // also need to update byCardId to remove collection id from removed cards
      removeCards.forEach((cardId) => {
        nextState.userCollections.byCardId = {
          ...nextState.userCollections.byCardId,
          [cardId]: (nextState.userCollections.byCardId[cardId] || []).filter((colId) => colId !== id),
        };
      });
      return { ...state, ...nextState };
    }

    case ADD_CARD_TO_COLLECTION: {
      const { id: collectionId, cardId } = action.payload;
      const collection = state.userCollections.byId[collectionId];
      if (!collection) return state;

      // Add cardId to the collection's cards array if not already present
      const updatedCards = collection.cards.includes(cardId) ? collection.cards : [...collection.cards, cardId];

      nextState.userCollections = {
        ...state.userCollections,
        byId: {
          ...state.userCollections.byId,
          [collectionId]: {
            ...collection,
            cards: updatedCards,
          },
        },
        byCardId: {
          ...state.userCollections.byCardId,
          [cardId]: state.userCollections.byCardId[cardId]
            ? [...state.userCollections.byCardId[cardId], collectionId]
            : [collectionId],
        },
      };
      return { ...state, ...nextState };
    }

    case REMOVE_CARD_FROM_COLLECTION: {
      const { id: collectionId, cardId } = action.payload;
      const collection = state.userCollections.byId[collectionId];
      if (!collection) return state;

      // Remove cardId from the collection's cards array
      const updatedCards = collection.cards.filter((id) => id !== cardId);

      nextState.userCollections = {
        ...state.userCollections,
        byId: {
          ...state.userCollections.byId,
          [collectionId]: {
            ...collection,
            cards: updatedCards,
          },
        },
        byCardId: {
          ...state.userCollections.byCardId,
          [cardId]: (state.userCollections.byCardId[cardId] || []).filter((id) => id !== collectionId),
        },
      };
      return { ...state, ...nextState };
    }

    case CREATE_COLLECTION: {
      // Add the new collection to byId and allIds as before
      nextState.userCollections = {
        ...state.userCollections,
        byId: {
          ...state.userCollections.byId,
          [action.payload.id]: {
            id: action.payload.id,
            name: action.payload.name,
            cards: action.payload.cards,
          },
        },
        allIds: [...state.userCollections.allIds, action.payload.id],
        byCardId: {
          ...state.userCollections.byCardId,
          ...action.payload.cards.reduce((acc, cardId) => {
            // If cardId already exists, append the collection id, else create a new array
            acc[cardId] = state.userCollections.byCardId[cardId]
              ? [...state.userCollections.byCardId[cardId], action.payload.id]
              : [action.payload.id];
            return acc;
          }, {}),
        },
      };
      return { ...state, ...nextState };
    }

    case DELETE_COLLECTION: {
      // Remove the collection from byId and allIds as before
      // Also need to remove the collection id from byCardId entries
      const collectionToDelete = state.userCollections.byId[action.payload.id];
      if (!collectionToDelete) return state;

      const updatedByCardId = { ...state.userCollections.byCardId };
      collectionToDelete.cards.forEach((cardId) => {
        updatedByCardId[cardId] = (updatedByCardId[cardId] || []).filter((id) => id !== action.payload.id);
        if (updatedByCardId[cardId].length === 0) {
          delete updatedByCardId[cardId];
        }
      });

      nextState.userCollections = {
        ...state.userCollections,
        byId: Object.keys(state.userCollections.byId).reduce((acc, id) => {
          if (id !== action.payload.id) {
            acc[id] = state.userCollections.byId[id];
          }
          return acc;
        }, {}),
        allIds: state.userCollections.allIds.filter((id) => id !== action.payload.id),
        byCardId: updatedByCardId,
      };
      return { ...state, ...nextState };
    }

    default:
      break;
  }
  return state;
};

export default collections;
